import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Canceler } from "axios";

import { IUser, IUsersState } from "./types";

import { MarketContext } from "src/services/contexts/markets/MarketContext";
import New from "./components/New";
import Edit from "./components/Edit";
import Subpage from "../components/Subpage";
import API from "src/services/api";
import { Button } from "src/components";
import { toast } from "react-toastify";

class Users extends React.Component<RouteComponentProps, IUsersState> {
  static contextType = MarketContext;
  context!: React.ContextType<typeof MarketContext>;
  reqCancelers: Canceler[] = [];

  state: IUsersState = {
    items: [],
    markets: [],
    resetting: [],
    isLoading: true,
    isExporting: false,
  };

  columns = ["Username", "Roles", "Expires On"];

  getColumnValues = (user: IUser) => {
    return [
      user.email,
      user.roles.join(", "),
      <>
        <span className="mr-2">{user.expirationDate || "Never"}</span>
        {user.roles.indexOf("SuperAdmin") === -1 && (
          <Button
            onClick={this.resetExpiration(user)}
            type="button"
            size="small"
            loading={this.state.resetting.includes(user.id)}
            loadingLabel="Resetting"
          >
            Reset
          </Button>
        )}
      </>,
    ];
  };

  fillMarketsForGlobalRoles = (user: IUser): IUser => ({
    ...user,
    localContentRoles: user.roles.includes("ContentAdmin")
      ? this.context.localUserAdminProfiles
      : user.localContentRoles,
    localUserRoles: user.roles.includes("UserAdmin")
      ? this.context.localUserAdminProfiles
      : user.localUserRoles,
  });

  async componentDidMount() {
    const itemsRequest = API.ADMIN.USERS.getAll();
    this.reqCancelers = [itemsRequest.cancel];
    const itemsData = await itemsRequest.getData();
    this.reqCancelers = [];

    const markets = this.context.localUserAdminProfiles;
    const items = itemsData.map(this.fillMarketsForGlobalRoles);
    this.setState({ items, markets, isLoading: false });
  }
  componentWillUnmount() {
    this.reqCancelers.forEach((cancel) => cancel());
  }

  updateUser = (user: IUser) => {
    this.setState(({ items }) => {
      const userIndex = items.findIndex((item) => item.id === user.id);
      return {
        items: [
          ...items.slice(0, userIndex),
          this.fillMarketsForGlobalRoles(user),
          ...items.slice(userIndex + 1),
        ],
      };
    });
  };

  add = async (user: IUser) => {
    const newUser = await API.ADMIN.USERS.add(user);
    this.setState(({ items }) => ({
      items: [this.fillMarketsForGlobalRoles(newUser), ...items],
    }));
  };

  update = async (user: IUser) => {
    const updatedUser = await API.ADMIN.USERS.update(user);
    this.updateUser(updatedUser);
  };

  delete = async (user: IUser) => {
    const success = await API.ADMIN.USERS.delete(user);
    if (success) {
      // delete user from user list
      this.setState(({ items }) => ({
        items: items.filter((x) => x.id !== user.id),
      }));
    }
  };

  export = async () => {
    this.setState({ isExporting: true });
    await API.ADMIN.USERS.EXPORT.excel();
    this.setState({ isExporting: false });
  };

  resetExpiration = (user: IUser) => async () => {
    this.setState((state) => ({
      resetting: [...state.resetting, user.id],
    }));
    try {
      const updatedUser = await API.ADMIN.USERS.resetExpiration(user);
      this.updateUser(updatedUser);
    } catch (error) {
      toast.error("Resetting expiration failed", error.message);
    }
    this.setState((state) => ({
      resetting: state.resetting.filter((id) => id !== user.id),
    }));
  };

  getSearchString = (user: IUser) => `${user.email} ${user.roles.join(" ")}`;

  NewForm = (props: any) => {
    return <New add={this.add} markets={this.state.markets} {...props} />;
  };

  EditForm = (props: any) => {
    return (
      <Edit
        update={this.update}
        delete={this.delete}
        markets={this.state.markets}
        {...props}
      />
    );
  };

  render() {
    return (
      <Subpage
        currentPath={this.props.location.pathname}
        NewForm={this.NewForm}
        EditForm={this.EditForm}
        columns={this.columns}
        getColumnValues={this.getColumnValues}
        getSearchString={this.getSearchString}
        items={this.state.items}
        isLoading={this.state.isLoading}
      >
        <Button
          size="small"
          background="grey"
          className="mr-4"
          onClick={this.export}
          loading={this.state.isExporting}
          disabled={this.state.isExporting}
        >
          Export
        </Button>
      </Subpage>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/views/Admin/Users/Users.tsx